// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/calendar.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal CSS */

.downloadClass {
    max-width: 67.375rem !important;
    padding-top: 2rem;
}

.redFont {
    color: #e50000;
    font-size: medium;
}

.modal-body {
    font-size: 0.81rem;
    color: #595d60;
    padding: 0.7rem !important;
}

.shadow-textarea textarea.form-control::placeholder {
    font-weight: 300;
}

.shadow-textarea textarea.form-control {
    padding-left: 0.8rem;
}

.actionPlanModal-toyota .modal-dialog, .actionPlanModal-toyota .modal-content {
    border-radius: 24px !important;
    border: 1px solid #e50000 !important;
}

.actionPlanModal-lexus .modal-dialog, .actionPlanModal-lexus .modal-content {
    border-radius: 24px !important;
    border: 1px solid #252525 !important;
}

.actionPlanModal-toyota .modal-header {
    background-color: #e50000;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.actionPlanModal-lexus .modal-header {
    background-color: #252525;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.modal-title {
    color: white;
    font-size: 1.0rem !important;
    padding-left: 0.5rem;
}

.modal-header .close {
    color: white;
    padding: 1.5rem !important;
    margin: -1.3rem -1rem -2rem auto !important;
}

.redFont {
    color: #e50000;
}

.actionPlanModal-toyota .textFont {
    color: #e50000;
}

.actionPlanModal-lexus .textFont {
    color: #252525;
}

.actionPlanModal-toyota .textFontHistory {
    color: #e50000;
    margin: 0px;
}

.actionPlanModal-lexus .textFontHistory {
    color: #252525;
    margin: 0px;
}

.downloadModal .css-10nd86i {
    width: 50%;
}

.actionPlanModal-toyota .css-10nd86i svg {
    color: #e50000;
}

.actionPlanModal-lexus .css-10nd86i svg {
    color: #252525;
}

.downloadModal .css-10nd86i .css-1492t68 {
    text-indent: -9999px;
}

.downloadModal .css-va7pk8 {
    color: #595d60 !important;
}

.modal-body {
    font-size: 0.81rem;
    color: #595d60;
    padding: 0.7rem !important;
}

.downloadClass .react-datepicker__input-container {
    width: 12rem;
}

.widget-header-toyota .react-datepicker__close-icon::after {
    background-color: #e50000 ;
}

.widget-header-lexus .react-datepicker__close-icon::after {
    background-color: #252525;
}

.downloadClass #startDate, .downloadClass #endDate {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right;
    cursor: pointer;
}

.downloadClass .statusDD {
    width: 12rem;
}

.downloadClass input {
    border-radius: 0.25rem !important;
}

.historyDiv {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    padding: 1rem;
    overflow-y: auto;
    height: 8rem;
}`, "",{"version":3,"sources":["webpack://./src/components/actionPlanModal/index.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;IACI,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yDAAyD;IACzD,4BAA4B;IAC5B,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB","sourcesContent":["/* Modal CSS */\n\n.downloadClass {\n    max-width: 67.375rem !important;\n    padding-top: 2rem;\n}\n\n.redFont {\n    color: #e50000;\n    font-size: medium;\n}\n\n.modal-body {\n    font-size: 0.81rem;\n    color: #595d60;\n    padding: 0.7rem !important;\n}\n\n.shadow-textarea textarea.form-control::placeholder {\n    font-weight: 300;\n}\n\n.shadow-textarea textarea.form-control {\n    padding-left: 0.8rem;\n}\n\n.actionPlanModal-toyota .modal-dialog, .actionPlanModal-toyota .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #e50000 !important;\n}\n\n.actionPlanModal-lexus .modal-dialog, .actionPlanModal-lexus .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #252525 !important;\n}\n\n.actionPlanModal-toyota .modal-header {\n    background-color: #e50000;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.actionPlanModal-lexus .modal-header {\n    background-color: #252525;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.modal-title {\n    color: white;\n    font-size: 1.0rem !important;\n    padding-left: 0.5rem;\n}\n\n.modal-header .close {\n    color: white;\n    padding: 1.5rem !important;\n    margin: -1.3rem -1rem -2rem auto !important;\n}\n\n.redFont {\n    color: #e50000;\n}\n\n.actionPlanModal-toyota .textFont {\n    color: #e50000;\n}\n\n.actionPlanModal-lexus .textFont {\n    color: #252525;\n}\n\n.actionPlanModal-toyota .textFontHistory {\n    color: #e50000;\n    margin: 0px;\n}\n\n.actionPlanModal-lexus .textFontHistory {\n    color: #252525;\n    margin: 0px;\n}\n\n.downloadModal .css-10nd86i {\n    width: 50%;\n}\n\n.actionPlanModal-toyota .css-10nd86i svg {\n    color: #e50000;\n}\n\n.actionPlanModal-lexus .css-10nd86i svg {\n    color: #252525;\n}\n\n.downloadModal .css-10nd86i .css-1492t68 {\n    text-indent: -9999px;\n}\n\n.downloadModal .css-va7pk8 {\n    color: #595d60 !important;\n}\n\n.modal-body {\n    font-size: 0.81rem;\n    color: #595d60;\n    padding: 0.7rem !important;\n}\n\n.downloadClass .react-datepicker__input-container {\n    width: 12rem;\n}\n\n.widget-header-toyota .react-datepicker__close-icon::after {\n    background-color: #e50000 ;\n}\n\n.widget-header-lexus .react-datepicker__close-icon::after {\n    background-color: #252525;\n}\n\n.downloadClass #startDate, .downloadClass #endDate {\n    background-image: url(\"../../assets/images/calendar.png\");\n    background-repeat: no-repeat;\n    background-position: right;\n    cursor: pointer;\n}\n\n.downloadClass .statusDD {\n    width: 12rem;\n}\n\n.downloadClass input {\n    border-radius: 0.25rem !important;\n}\n\n.historyDiv {\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    padding: 1rem;\n    overflow-y: auto;\n    height: 8rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
